module.exports = __webpack_public_path__ + "img/geckos.81295888.png";